module.exports = __webpack_public_path__ + "static/media/barrensbg.722b8203.png";